module.exports = __webpack_public_path__ + "img/4.ade97d72.png";